module.exports = __webpack_public_path__ + "img/users.8e85e4fe.svg";